import { render } from "./DetailedSearchFooter.vue?vue&type=template&id=0c7b7f6c&scoped=true&ts=true"
import script from "./DetailedSearchFooter.vue?vue&type=script&lang=ts"
export * from "./DetailedSearchFooter.vue?vue&type=script&lang=ts"

import "./DetailedSearchFooter.vue?vue&type=style&index=0&id=0c7b7f6c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7b7f6c"]])

export default __exports__